import { useEffect, useCallback } from "react";

const useAnimation = (animation, setAnimation) => {
  const scrollListener = useCallback(() => {
    if (window.scrollY >= 150 && (animation === false || animation === null)) {
      setAnimation(true);
    } else if (window.scrollY <= 150 && animation === true) {
      setAnimation(false);
    }
  }, [animation, setAnimation]);

  useEffect(() => {
    window.addEventListener("scroll", scrollListener);
    return () => {
      window.removeEventListener("scroll", scrollListener);
    };
  }, [scrollListener]);
};

export default useAnimation;
